import { getRequest } from "../RestServices";
import * as urls from "../../api/updateActiveUnits/url";
export const getProfilesForAtt = async () => {
  try {
    return await getRequest(urls.GET_ATT_PROFILES);
  } catch (err) {
    return err;
  }
};
